import { Validators } from '@angular/forms'
import { ElementState } from '@maskito/core/lib/types'

import { QuestionMeasurementType } from '../../model/question'
import { QuestionBase, QuestionOptions } from './base.question.class'

interface MeasurementQuestionOptions extends QuestionOptions<string> {
  measurementType?: QuestionMeasurementType
}

export class MeasurementQuestion extends QuestionBase<string> {
  controlType = 'input' // this is just a text field with some custom masks
  type = 'text'

  constructor(options: MeasurementQuestionOptions = {}) {
    super(options)

    switch (options.measurementType) {
      case QuestionMeasurementType.Weight: {
        this.type = 'number'
        this.min = 0.1
        this.max = 1000
        this.validators.push(Validators.min(0.1))
        this.validators.push(Validators.max(1000))

        if (!this.hint) {
          this.hint = 'In pounds'
        }
        break
      }

      case QuestionMeasurementType.Length: {
        const feetIndicator = `'`
        const inchesIndicator = `"`
        const maxFeet = 15
        this.mask = {
          mask: (input: ElementState) => {
            const val = input.value.split(' ')
            const feet = parseInt(val[0], 10)
            const inches = val[1] && parseInt(val[1][0], 10)

            // if they enter 1 foot, there is a chance they are above 9',
            // which is rare by it has happened before
            if (
              (feet === 1 || feet >= 10) &&
              feet <= maxFeet &&
              val[1] !== feetIndicator
            ) {
              if (typeof inches === 'number' && inches === 1) {
                return [
                  /[1-9]/,
                  /[0-5]|\s/,
                  feetIndicator,
                  ' ',
                  /[1-9]/,
                  /[0-1]/,
                  inchesIndicator,
                ]
              } else {
                return [
                  /[1-9]/,
                  /[0-5]|\s/,
                  feetIndicator,
                  ' ',
                  /[1-9]/,
                  inchesIndicator,
                ]
              }
            } else {
              if (typeof inches === 'number' && inches === 1) {
                return [
                  /[1-9]/,
                  feetIndicator,
                  ' ',
                  /[1-9]/,
                  /[0-1]/,
                  inchesIndicator,
                ]
              } else {
                return [/[1-9]/, feetIndicator, ' ', /[1-9]/, inchesIndicator]
              }
            }
          },
        }

        if (!this.hint) {
          this.hint = 'In feet and inches'
        }
        break
      }

      case QuestionMeasurementType.Age: {
        this.mask = {
          mask: (input: ElementState) => {
            const val = input.value.split(' ')
            const years = parseInt(val[0], 10)
            const months = val[1] && parseInt(val[1][0], 10)

            if (years >= 3) {
              return [/[1-9]/, /[0-9]+/, 'Y']
            } else if (months === 1) {
              return [/[0-9]/, 'Y', ' ', /[0-9]/, /[0-1]/, 'M']
            } else {
              return [/[0-9]/, 'Y', ' ', /[0-9]/, 'M']
            }
          },
        }

        if (!this.hint) {
          this.hint = 'In years and months'
        }

        break
      }

      case QuestionMeasurementType.Temp: {
        // this.mask = {
        //   mask: (input: string) => {
        //     return [/\d/, 'F']
        //   },
        //   showMask: true,
        //   guide: true,
        // }

        if (!this.hint) {
          this.hint = 'In fahrenheit'
        }

        break
      }

      case QuestionMeasurementType.Numeric: {
        this.type = 'number'
        break
      }

      case QuestionMeasurementType.Ssn: {
        this.mask = {
          mask: [
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            /\d/,
            /\d/,
          ],
        }
        this.validators.push(Validators.minLength(11))

        break
      }
    }
  }
}
